import { inject, Injector } from '@angular/core';

import { provide } from '@core/common-legacy';
import { AuthHelpers, AuthorisationStrategy, AuthService, CookieService } from '@core/http-legacy';

import { appConfig } from './app/config';
import { ReferralsAuthStrategy } from './referrals-auth-strategy';

export const bootstrapInjector = Injector.create({
  name: 'bootstrap',
  providers: [
    CookieService,
    AuthHelpers,
    provide(AuthorisationStrategy, {
      useFactory: () => new ReferralsAuthStrategy(appConfig, inject(CookieService)),
    }),
    AuthService,
  ],
});
